import type from "../commons/providerActionStatus";

const DEFAULT_STATE = {
    providerInfo: null,
    error: null,
    requestState: false,
    status: null,
};

export const providerReducer = (state = DEFAULT_STATE, action) => {
    const actionType = action.type;
    let providerInfo;
    let error = action.error;
    let requestState = action.requestState;
    let status = action.status;

    switch (actionType) {
        case type.GET_PROVIDER_DETAILS_REQUEST:
            return { ...state, providerInfo: null, requestState, status };

        case type.GET_PROVIDER_DETAILS_SUCCESS:
            providerInfo = action.result;
            return {
                ...state,
                providerInfo,
                requestState,
                status,
            };

        case type.GET_PROVIDER_DETAILS_FAILURE:
            return { ...state, error, requestState, status };

        case type.UPDATE_PROVIDER_DETAILS_REQUEST:
            return { ...state, providerInfo: null, requestState, status };

        case type.UPDATE_PROVIDER_DETAILS_SUCCESS:
            providerInfo = action.result;
            return {
                ...state,
                providerInfo,
                requestState,
                status,
            };

        case type.UPDATE_PROVIDER_DETAILS_FAILURE:
            return { ...state, error, requestState, status };

        default:
            return state;
    }
};
